"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListView_1 = require("../ListView");
var FlexLayout = /** @class */ (function () {
    /**
     *
     * @param maxRowHeight max row height in pixels
     * @param photoRightMargin max right margin of each item in pixels
     * @param photoBottomMargin max bottom margin of each item in pixels
     */
    function FlexLayout(maxRowHeight, photoRightMargin, photoBottomMargin) {
        this.orientation = ListView_1.Orientation.Vertical;
        this.maxRowHeight = maxRowHeight;
        this.photoRightMargin = photoRightMargin;
        this.photoBottomMargin = photoBottomMargin;
    }
    FlexLayout.prototype.layout = function (itemSizes, viewportSize) {
        var _this = this;
        var targetAspect = this.maxRowHeight / viewportSize.width;
        var rows = [];
        var items = [];
        var currentWidth = 0;
        var overflowPixels = 0;
        // Put elements by rows
        itemSizes.forEach(function (photo) {
            var photoAspect = photo.height / photo.width;
            var photoWidth = _this.maxRowHeight / photoAspect;
            // Adding right margin only, when there is an another element to left.
            var margin = (currentWidth === 0 ? 0 : _this.photoRightMargin);
            currentWidth += margin + photoWidth;
            var rowAspect = _this.maxRowHeight / currentWidth;
            overflowPixels = currentWidth - viewportSize.width;
            items.push({ photo: photo, width: photoWidth, height: photoWidth * photoAspect });
            if (rowAspect <= targetAspect) {
                rows.push({ overflowPixels: overflowPixels, items: items, rowWidth: currentWidth });
                currentWidth = 0;
                items = [];
            }
        });
        // Do not add empty rows.
        if (items.length > 0) {
            rows.push({ overflowPixels: overflowPixels, items: items, rowWidth: currentWidth });
        }
        // Correct according the overflowPixels.
        var result = [];
        rows.forEach(function (row) {
            if (row.overflowPixels > 0) {
                row.items.forEach(function (item, index) {
                    // Store aspect ratio.
                    var aspect = item.height / item.width;
                    var percentOfWidth = (item.width + (index === 0 ? 0 : _this.photoRightMargin)) / row.rowWidth;
                    item.width -= percentOfWidth * row.overflowPixels;
                    // Use aspect ratio to calculate the correct height.
                    item.height = aspect * item.width;
                });
            }
            result.push(row.items);
        });
        // Calculate x and y values.
        var gridList = [];
        var y = 0;
        var x = 0;
        result.forEach(function (gridRow) {
            x = 0;
            gridRow.forEach(function (item) {
                gridList.push({
                    width: item.width,
                    height: item.height,
                    x: x,
                    y: y
                });
                x = x + item.width + _this.photoRightMargin;
            });
            y = y + gridRow[0].height + _this.photoBottomMargin;
        });
        return gridList;
    };
    return FlexLayout;
}());
exports.FlexLayout = FlexLayout;
